import { render, staticRenderFns } from "./_account.vue?vue&type=template&id=4404fa00&lang=pug&"
import script from "./_account.vue?vue&type=script&lang=js&"
export * from "./_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports